import { Gender } from 'common/types';

import locales from '../locales';

export const GENDER_OPTIONS = [
  { label: locales.legalTitleMale, value: Gender.MALE },
  { label: locales.legalTitleFemale, value: Gender.FEMALE },
];
